import { createAction } from '@reduxjs/toolkit';
import { saveToLocalStorage } from '@/lib/helpers';

export const setSalesOrdersReportActiveFilters = createAction(
  'sales-orders-report/active-filters/save'
);
export const _setSalesOrdersReportActiveFilters =
  (filterUpdate, initialSeason = '') =>
  (dispatch, getState) => {
    const state = getState();
    const salesOrdersReportSearchState = state.salesOrdersReportSearch;
    const { activeFilters } = salesOrdersReportSearchState;

    let newFilters = {};

    if (filterUpdate === null) {
      newFilters = {
        season: initialSeason,
        campaign: '',
        onlyUnorderedProducts: false,
        campaignLevelRoles: [],
        brands: [],
        productType: '',
        targetGroups: [],
        category: '',
        sport: '',
        roles: [],
        status: '',
        shopUuid: '',
      };
    } else {
      newFilters = {
        ...activeFilters,
        ...filterUpdate,
      };
    }

    saveToLocalStorage('salesOrdersReportActiveFilters', newFilters);
    dispatch(setSalesOrdersReportActiveFilters(newFilters));
  };
